/**
 * Cloud status icons for autosave UI. All variants share the same cloud
 * outline path and differ only in their interior glyph (check, exclamation,
 * or check in softer treatment).
 */

const cloudOutline =
  'M6 13H12C13.933 13 15.5 11.433 15.5 9.5C15.5 7.8 14.2 6.4 12.55 6.16C12.25 4.4 10.7 3 8.75 3C7.25 3 5.93 3.86 5.32 5.13C5.14 5.11 4.96 5.1 4.77 5.1C3.13 5.1 1.8 6.43 1.8 8.07C1.8 9.71 3.13 11.04 4.77 11.04';

/** Cloud with checkmark — "saved successfully" state. */
export const SavedCloudIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden="true"
  >
    <path
      d={cloudOutline}
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 9.4L8.2 11.4L11.9 7.4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Cloud with exclamation — "error / couldn't save" state. */
export const ErrorCloudIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden="true"
  >
    <path
      d={cloudOutline}
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 7V10"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <circle cx="9" cy="11.6" r="0.7" fill="currentColor" />
  </svg>
);

/** Cloud with checkmark (same as Saved) — "idle / no unsaved edits" state. */
export const IdleCloudIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden="true"
  >
    <path
      d={cloudOutline}
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 9.4L8.2 11.4L11.9 7.4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
